/*
* Checks whether a journal entry's debits offset its credits
* @param {VueComponent} self
* @return boolean
*/
export function isJeBalanced (self) {
  if (!self.lines || !self.lines.length) return false   // No lines so it can't be balanced
  const debits = parseFloat(parseFloat(self.form.debits_decimal).toPrecision(8))
  const credits = parseFloat(parseFloat(self.form.credits_decimal).toPrecision(8))
  const sum = debits + credits
  if (sum > 0) {
    return false
  } else if (sum === 0) {
    return true
  }
  return false
}

/*
* Checks whether a petty cash entry's is in balance.  Balanced for a PC is either:
* 1) debits = envelope amount
* 2) debits = credits (new)
* @param {VueComponent} self
* @return boolean
*/
export function isPcBalanced (self) {
  if (!self.lines || !self.lines.length) return false   // No lines so it can't be balanced
  let sum = 0                                           // Add up sum of all lines
  for (let i in self.lines) {
    if (self.lines[i].deleteLine) continue
    let amt = self.lines[i].hasOwnProperty('form') ? self.lines[i].form.amount_decimal : self.lines[i].amount_decimal
    sum += (amt && !isNaN(amt)) ? parseFloat(amt) : 0
  }
  if (!isNaN(sum)) sum = parseFloat(sum.toFixed(8))
  return (sum === parseFloat(self.form.amount_decimal) || sum + parseFloat(self.form.amount_decimal) === 0 || sum === 0)
}

/*
* Checks whether the sum of this transaction's lines equals the transaction amount (for DRAFT, OPEN, and AUDITED
* transactions) or 0 (for POSTED transactions)
* @param {VueComponent} self
* @return void
*/
export function isTransactionBalanced (self) {
  if (!self.lines || !self.lines.length) {
    self.transactionIsBalanced = false
    return
  }
  const notDraftOrOpen = self.originalHeader && ['POSTED', 'CLOSED', 'VOIDED'].includes(self.originalHeader.status)
  let sum = self.lines.map(v => {
    if (!v || v.deleteLine) return 0
    let amt = v.hasOwnProperty('form') ? v.form.amount_decimal : v.amount_decimal
    return amt ? parseFloat(amt) : 0
  })
  sum = sum.reduce((sum, v) => parseFloat(sum.toFixed(2)) + v)
  if (!isNaN(sum)) sum = parseFloat(sum.toPrecision(10))
  if (notDraftOrOpen) {
    self.transactionIsBalanced = !!(sum === 0 || sum === parseFloat(self.form.amount_decimal))
  } else {
    self.transactionIsBalanced = !!((sum || sum === 0) && (sum === parseFloat(self.form.amount_decimal)))
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/DataEntryViews/IsTransactionBalanced.js